(function () {

    AutoSchedulingService.$inject = ['$q', '$timeout', 'TeamScheduleService', 'TSUsersService', 'ScheduleDataServiceV2', 'ScheduleCostsServiceV2', 'minorSchedulingService', 'breaksManagementService', 'ShiftTemplateUtils', 'userServices', 'workVisasService', 'breaksAutoAssignService'];

    function AutoSchedulingService($q, $timeout, TeamScheduleService, TSUsersService, ScheduleDataServiceV2, ScheduleCostsServiceV2, minorSchedulingService, breaksManagementService, ShiftTemplateUtils, userServices, workVisasService, breaksAutoAssignService) {
        var self = this;

        const MILLISECOND = 1000;
        const SECOND = 1;
        const MINUTE = 60 * SECOND;
        const HOUR = 60 * MINUTE;
        const DAY = 24 * HOUR * MILLISECOND;
        var NEW_HIRED_THRESHOLD = 30;
        const DOUBLE_SHIFT_HOURS_VIOLATION = 20;

        var activeBrandUsers;
        var activeBrandGFEs;
        var autoAssignData;
        let usersInfoCache = {};
        let daysFormat = {};
        let usersWorkingHoursPerDayMap = {};
        let minorRuleInBreaksRulesMap = {};

        const prepareIncentivePayments = (shift, shiftDay) => {
            const userCosts = ScheduleCostsServiceV2.flatData?.costs?.[shift.user_id];
            const isHourlyEmployee = !shift.user_id || userCosts?.pay_type?.[shiftDay]?.type === 'HOURLY';
            return (
                isHourlyEmployee ? (
                    shift.incentive_payments.filter((incentivePayment) => incentivePayment.type === 'FIXED') ?? []
                ) : []
            );
        }

        var isWithin = function (shift1, shift2) {
            var shift1Start, shift2Start, shift1End, shift2End;

            shift1.start_time_value = shift1.start_time_value || new Date(shift1.start_time).getTime();
            shift2.start_time_value = shift2.start_time_value || new Date(shift2.start_time).getTime();
            shift1.end_time_value = shift1.end_time_value || new Date(shift1.end_time).getTime();
            shift2.end_time_value = shift2.end_time_value || new Date(shift2.end_time).getTime();

            shift1Start = shift1.start_time_value;
            shift2Start = shift2.start_time_value;
            shift1End = shift1.end_time_value;
            shift2End = shift2.end_time_value;

            if (shift1Start >= shift2Start && shift1End <= shift2End) {
                return true;
            }

            return false;
        };

        var getMinutesBetweenShifts = function (shift1, shift2) {
            shift1.end_time_value = shift1.end_time_value || new Date(shift1.end_time).getTime();
            shift2.start_time_value = shift2.start_time_value || new Date(shift2.start_time).getTime();

            return (shift2.start_time_value - shift1.end_time_value) / (60 * 1000);
        };

        var getIntersectionPerc = function (shift1, shift2) {
            var shift1Start, shift2Start, shift1End, shift2End;

            shift1.start_time_value = shift1.start_time_value || new Date(shift1.start_time).getTime();
            shift2.start_time_value = shift2.start_time_value || new Date(shift2.start_time).getTime();
            shift1.end_time_value = shift1.end_time_value || new Date(shift1.end_time).getTime();
            shift2.end_time_value = shift2.end_time_value || new Date(shift2.end_time).getTime();

            shift1Start = shift1.start_time_value;
            shift2Start = shift2.start_time_value;
            shift1End = shift1.end_time_value;
            shift2End = shift2.end_time_value;

            var intersectionStart = shift1Start > shift2Start ? shift1Start : shift2Start;
            var intersectionEnd = shift1End < shift2End ? shift1End : shift2End;
            var intersection = intersectionEnd - intersectionStart;
            var perc = intersection / (shift1End - shift1Start);

            return perc > 0? perc: 0;
        };

        var doOverlap = function (shift1, shift2) {
            var shift1Start, shift2Start, shift1End, shift2End;

            shift1.start_time_value = shift1.start_time_value || new Date(shift1.start_time).getTime();
            shift2.start_time_value = shift2.start_time_value || new Date(shift2.start_time).getTime();
            shift1.end_time_value = shift1.end_time_value || new Date(shift1.end_time).getTime();
            shift2.end_time_value = shift2.end_time_value || new Date(shift2.end_time).getTime();

            shift1Start = shift1.start_time_value;
            shift2Start = shift2.start_time_value;
            shift1End = shift1.end_time_value;
            shift2End = shift2.end_time_value;

            if (
                (shift1Start < shift2Start && shift1End <= shift2Start) ||
                (shift1End > shift2End && shift1Start >= shift2End)
            ) {
                return false;
            }

            return true;
        };

        // prod codes server, food-runner, head-waiter
        const waiterCodes = ['server'];
        const headWaiterCodes = ['head-waiter', 'Head Waiter'];
        const runnerCodes = ['food-runner'];

        // prod brand: 709249
        // uat brand: 709249
        // dev brand: 11288040, 10117966
        /**
         * if the brand in this list then we will do the following in the auto assign:
         * - the food runner shifts will be sorted to the top of the list so they are assigned first
         * - when getting the suitable users for the shift (if the shift has job titles on and the shift is food runner shift - defined in the runnerCodes -) then we will be getting the users with food-runner and waiter and head waiter positions
         * - then for the food-runner shifts if it has job titles we will run it as if the match_job_title is enabled so that the shifts are assigned based on the shift job titles (the user with the most qualified job title level is more suitable to pick up the shift)
         * - at the end (when assigning the shift to the user) we will not be getting the most suitable user for the assigning instead we will get the food-runner users first and if there is no users with that position, then we will take the best waiter/head-waiter user.
         * - in the quick assign flow we will do a sorting on the users list to make the lowest food runner user come higher in the list than the highest waiter/head-waiter user.
         * - if no job titles defined on the shift, then that shift can only be picked by food runners users and will not be assigned to waiter/head-waiter users
         * @param brandId the brand id to check if the flow is enabled on.
         * @returns {boolean} returns true on the brands with the flow enabled.
         */
        let isPositionOrderedApplied = function (brandId) {
            return [
                709249,
                11288040, 10117966
            ].includes(brandId);
        };

        var calculateScore = function (item, options) {
            var score = 0;

            if (item['possible_shifts'] === 0) { // This is the only shift this user can be assigned to
                score += 10;
            }

            if (item['isUnavailable']) {
                score -= 100;
            }

            if (item['exceedsMaxHoursValue'] > 1) {
                score -= (100 * item['exceedsMaxHoursValue']);
            }

            if (item['alreadyScheduledSameDay']) {
                score -= 50;
            }

            if (!options || options['consider_requests'] || options['consider_preferred']) {
                if (item['requestedUnavailability']) {
                    score -= 50;
                }
            }

            if (options && options['skilled_at_busy'] && item['busy_shift_position']) {
                var skillLevel = (item['skillLevel'] && item['skillLevel']['id']) || 0;
                score += (skillLevel * 10);
            }

            if (options && options['skilled_at_busy'] && item['busy_shift_overall']) {
                var skillLevel = (item['skillLevel'] && item['skillLevel']['id']) || 0;
                score += (skillLevel * 5);
            }

            if (item.checkShiftJobTitles && item.shiftJTResult?.match) {
                score += (item.shiftJTResult.match * 10);
                score += (6 - item.shiftJTResult.avg_level) * 5;
            }

            if (!options || (options['consider_preferred'])) {
                if (item['isWorkable']) {
                    if (options && options['consider_preferred_policy'] === 'CONSIDER') {
                        score += (item['workableOverlapPerc'] * 50);
                    } else {
                        score += 100;
                    }
                }
            }

            if (options && options['equal_hours']) {
                if (item['exceedsAvgHoursPerUserVal'] > 1) {
                    score -= (item['exceedsAvgHoursPerUserVal'] * 50);
                }
            }
            else if (item['numberOfScheduledDays']) {
                score += 5;
            }

            if (!options || options['optimize_cost']) {
                if (item['rate']) {
                    score -= (item['rate'] - 10) * 3;
                }

            }

            return score;
        };

        const getUserSortValue = (user1, user2) => {
            if (user1.score === user2.score) {
                return 0;
            }

            return user1.score > user2.score ? -1 : 1;
        }

        const applySortCriteria = (usersList) => {
            return usersList.sort(getUserSortValue);
        };

        var getActiveBrandTeamMembers = function () {
            var defer = $q.defer();

            if (activeBrandUsers) {
                defer.resolve(angular.copy(activeBrandUsers));
            }
            else {
                TSUsersService.getActiveBrandTeamMembers()
                    .then(function (users) {
                        activeBrandUsers = users;
                        defer.resolve(_.shuffle(activeBrandUsers));
                    })
                    .catch(function (err) {
                        console.error(err);
                    });
            }

            return defer.promise;
        };

        var getShiftUtilization = function (shift) {
            var shiftUtilization = shift['note'] && shift['note']['text'] || '';

            if (shiftUtilization.indexOf("%") > -1) {
                return parseFloat(shiftUtilization.slice(0, shiftUtilization.length - 1));
            }

            return 0;
        };

        var usersMap = {};
        var usersShiftKnockoutMap = {};
        var avgHoursPerUser = {};
        var userEligableShiftsCount = {};
        var totalShiftsHours = {};
        var shiftsPerPosition = {};

        const getPositionSortCriteria = (positionCodes, firstShiftPosition, secondShiftPosition, startFromWeekend) => {
            const isFirstPositionIncluded = positionCodes.includes(firstShiftPosition);
            const isSecondPositionIncluded = positionCodes.includes(secondShiftPosition);

            if (isFirstPositionIncluded && !isSecondPositionIncluded) {
                return startFromWeekend ? 1 : -1;
            } else if (!isFirstPositionIncluded && isSecondPositionIncluded) {
                return startFromWeekend ? -1 : 1;
            }

            return 0;
        }

        self.autoAssignShifts = function (brand, scheduleId, options, viewOptions, trackProgress) {
            var defer = $q.defer();

            var brandId = brand.id;
            var shiftsToAssign = [];
            var resultedShifts = [];
            minorRuleInBreaksRulesMap = {};
            usersMap = {};
            shiftsPerPosition = {};
            usersShiftKnockoutMap = {};
            avgHoursPerUser = {};
            userEligableShiftsCount = {};
            totalShiftsHours = {};

            var shiftsHoursMap = {'overall': []};
            var totalShiftBusyScore = {'overall': 0};
            var numberOfShifts = {'overall': 0};
            var averageShiftBusyScoreAvg = {'overall': 0};

            var minute = 60 * 1000; // In ms
            const nowInBrandTimezone = moment(Utils.getNowInBrandTimezoneByTimeZoneName(brand.timezoneName).format("YYYY-MM-DDTHH:mm:ss.SSS"));

            var selectedPositions = options['positions']? _.pluck(options['positions'], 'code'): [];
            var excludeUsers = options['exclude_users']? _.pluck(options['exclude_users'], 'id'): [];

            var selectedDayFormatted = viewOptions.type === 'DAILY' && viewOptions.day.format("MMM DD, YYYY");


            // Detect shifts included in auto assign
            // Based on day/week view, Only look for unassigned shifts, and check position/excluded users filters
            // Calculate shift busy score (compared to all shifts, and same position)
            for (var shiftId in ScheduleDataServiceV2.flatData['shifts']) {
                var shift = ScheduleDataServiceV2.flatData['shifts'][shiftId];
                var shiftStartTime = moment(shift.start_time).valueOf();
                var shiftEndTime = moment(shift.end_time).valueOf();

                shiftsHoursMap[shift.position.code] = shiftsHoursMap[shift.position.code] || [];
                totalShiftBusyScore[shift.position.code] = totalShiftBusyScore[shift.position.code] || 0;
                numberOfShifts[shift.position.code] = numberOfShifts[shift.position.code] || 0;
                totalShiftsHours[shift.position.code] = totalShiftsHours[shift.position.code] || 0;

                shift['busy_metric'] = { overall: 0, position: 0 };

                var shiftPeriods = 0;

                for (var j = shiftStartTime; j < shiftEndTime; j += (15 * minute)) {
                    var period = shiftsHoursMap[shift.position.code].find(function (item) {
                        return item.time === j;
                    });

                    if (!period) {
                        period = { time: j, shifts: 0 };
                        shiftsHoursMap[shift.position.code].push(period);
                    }

                    var overallPeriod = shiftsHoursMap['overall'].find(function (item) {
                        return item.time === j;
                    });

                    if (!overallPeriod) {
                        overallPeriod = { time: j, shifts: 0 };
                        shiftsHoursMap['overall'].push(overallPeriod);
                    }


                    shift['busy_metric'].position += period.shifts;
                    shift['busy_metric'].overall += overallPeriod.shifts;
                    period.shifts++;
                    overallPeriod.shifts++;
                    shiftPeriods++;
                }

                shift['busy_metric'].position = Utils.roundFloat(shift['busy_metric'].position / shiftPeriods);
                shift['busy_metric'].overall = Utils.roundFloat(shift['busy_metric'].overall / shiftPeriods);

                totalShiftBusyScore[shift.position.code] += shift['busy_metric'].position;
                totalShiftBusyScore['overall'] += shift['busy_metric'].overall;

                numberOfShifts[shift.position.code]++;
                numberOfShifts['overall']++;

                totalShiftsHours[shift.position.code] += (shift['costInfo']['time'] / 3600);

                if (!shift['user_id'] && (selectedPositions.length === 0 || selectedPositions.indexOf(shift.position.code) > -1) && (!selectedDayFormatted || shift['day'] === selectedDayFormatted)) {
                    shiftsToAssign.push(shift);
                }
            }

            for (var i in totalShiftBusyScore) {
                averageShiftBusyScoreAvg[i] = totalShiftBusyScore[i] / numberOfShifts[i];
            }

            if (!options || options['skilled_at_busy']) {
                shiftsToAssign = shiftsToAssign.sort(function (item1, item2) {
                    return item1['busy_metric'].position > item2['busy_metric'].position? -1: 1;
                });
            }

            var assignMap = {};

            trackProgress(0);

            loadDataForAutoAssign(viewOptions, options)
                .then(function () {
                    daysFormat = {};
                    usersWorkingHoursPerDayMap = {};
                    usersInfoCache = {};
                    var shiftsCount = shiftsToAssign.length;
                    var done = 0;
                    var progress = 0;

                    var updateInterval = setInterval(function () {
                        if (progress < (((done + 1) / shiftsCount) - 0.01)) {
                            progress += 0.01;
                            trackProgress(progress);
                        }
                    }, 300);


                    shiftsToAssign = shiftsToAssign.sort(function (item1, item2) {
                        return avgHoursPerUser[item1.position.code] > avgHoursPerUser[item2.position.code]? -1: 1;
                    });

                    if (ScheduleDataServiceV2.checkConsiderPositionWhileAssigning(brandId)) {
                        var utilizedShiftsFirst = options && options['utilized_shifts_first'];
                        var startFromWeekend = options && options['weekend_start'];

                        if (isPositionOrderedApplied(brandId) || utilizedShiftsFirst) {
                            shiftsToAssign = shiftsToAssign.sort((firstShift, secondShift) => {
                                if (isPositionOrderedApplied(brandId)) {
                                    const firstPosition = firstShift.position.code;
                                    const secondPosition = secondShift.position.code;

                                    const positionCriteria = getPositionSortCriteria(runnerCodes, firstPosition, secondPosition, startFromWeekend);

                                    if (positionCriteria !== 0) {
                                        return positionCriteria;
                                    }
                                }

                                if (utilizedShiftsFirst) {
                                    const item1Utilization = getShiftUtilization(firstShift);
                                    const item2Utilization = getShiftUtilization(secondShift);

                                    if (firstShift.day === secondShift.day) {
                                        if (startFromWeekend) {
                                            return item1Utilization - item2Utilization;
                                        } else {
                                            return item2Utilization - item1Utilization;
                                        }
                                    }
                                }

                                return 0;
                            });
                        }
                    }

                    let shiftsCache = {};
                    let shiftJobTitlesSortedIds = {};
                    let shiftBreaksCache = {};

                    const getShiftJobTitlesIdentifier = (shift) => {
                        if (shiftJobTitlesSortedIds[shift.id]) {
                            return shiftJobTitlesSortedIds[shift.id];
                        }

                        const jobTitles = shift.job_titles ?? [];
                        const jobTitlesSet = jobTitles.reduce((jobTitlesSet, jobTitle) => {
                            jobTitlesSet.add(jobTitle.job_title_id);
                            return jobTitlesSet;
                        }, new Set());

                        const sortedIds = Array.from(jobTitlesSet).sort((jobTitleId1, jobTitleId2) => jobTitleId1 > jobTitleId2 ? 1 : -1);
                        shiftJobTitlesSortedIds[shift.id] = sortedIds.join('_');

                        return shiftJobTitlesSortedIds[shift.id];
                    }

                    const getCacheIdentifier = (shift, options, userAge, excludeJobTitles) => {
                        let shiftJobTitlesIdentifier = '';
                        if (!excludeJobTitles && (!options || options.match_job_title)) {
                            shiftJobTitlesIdentifier = getShiftJobTitlesIdentifier(shift);
                        }
                        return [
                            shift.position.code,
                            shift.day,
                            shiftJobTitlesIdentifier,
                            userAge,
                            shift.start_time,
                            shift.end_time
                        ].join('_');
                    };

                    const findMatchingAssignee = (shiftX) => {
                        shiftsCache = {};

                        var shift = shiftX;
                        shift.is_busy = {
                            position: shift['busy_metric'].position >= averageShiftBusyScoreAvg[shift.position.code],
                            overall: shift['busy_metric'].overall >= averageShiftBusyScoreAvg['overall']
                        };

                        if (minorRuleInBreaksRulesMap[shift.day] === undefined) {
                            const breaksRules = ScheduleCostsServiceV2.getBreaksRulesForDay(shift.day);
                            minorRuleInBreaksRulesMap[shift.day] = breaksManagementService.checkIfThereIsOneMinorRule(breaksRules?.values);
                        }

                        userEligableShiftsCount = {};

                        if (!options || !options['selected_users']) {
                            for (var k in shiftsToAssign) {
                                var shiftToAssign = shiftsToAssign[k];

                                shiftToAssign.is_busy = {
                                    position: shiftToAssign['busy_metric'].position >= averageShiftBusyScoreAvg[shiftToAssign.position.code],
                                    overall: shiftToAssign['busy_metric'].overall >= averageShiftBusyScoreAvg['overall']
                                };
                                const shiftIdentifier = getCacheIdentifier(shiftToAssign, options, '', false);

                                if (!shiftsCache[shiftIdentifier]) {
                                    shiftsCache[shiftIdentifier] = getEligibleUsers(shiftToAssign, brand, nowInBrandTimezone, excludeUsers, angular.copy(options), true);
                                }

                                const possibleUsers = shiftsCache[shiftIdentifier];

                                if (possibleUsers[0]) {
                                    var highestScore = possibleUsers[0].score;

                                    for (var j in possibleUsers) {
                                        if (possibleUsers[j].score === highestScore) {
                                            userEligableShiftsCount[possibleUsers[j].user_id] = userEligableShiftsCount[possibleUsers[j].user_id] || 0;
                                            userEligableShiftsCount[possibleUsers[j].user_id]++;
                                        }
                                        else {
                                            break;
                                        }
                                    }
                                }
                            }
                        }

                        let eligibleUsers = getEligibleUsers(shift, brand, nowInBrandTimezone, excludeUsers, angular.copy(options));

                        if (eligibleUsers.length === 0) {
                            done++;
                            progress = done / shiftsCount;
                            trackProgress(progress);
                            return;
                        }

                        let eligibleUser = eligibleUsers[0];
                        let userId = eligibleUser.user_id;
                        let positionCode = shift.position.code;

                        if (
                            isPositionOrderedApplied(brand.id) &&
                            runnerCodes.includes(positionCode) &&
                            shift.job_titles?.length
                        ) {
                            eligibleUser = eligibleUsers.find((eligibleUser) => {
                                return eligibleUser.user.positions.find((position) => position.code === positionCode);
                            });

                            if (!eligibleUser) {
                                eligibleUser = eligibleUsers.find((eligibleUser) => {
                                    return eligibleUser.user.positions.find((position) => waiterCodes.includes(position.code));
                                }) ?? eligibleUsers[0];
                            }

                            userId = eligibleUser?.user_id;

                            positionCode = eligibleUser.userPosition.code;
                        }

                        shift.user_id = userId;
                        ScheduleDataServiceV2.flatData['users'][userId] = ScheduleDataServiceV2.flatData['users'][userId] || {shift_ids: []};
                        ScheduleDataServiceV2.flatData['users'][userId]['shift_ids'].push(shift.id);
                        assignMap[shift.id] = userId;

                        if (
                            (autoAssignData['crewMemberGroup'] && autoAssignData['crewMemberGroup'].indexOf(positionCode) > -1) ||
                            autoAssignData['managerGroup'] && autoAssignData['managerGroup'].indexOf(positionCode) > -1
                        ) {
                            positionCode = eligibleUser?.user?.positions?.[0]?.code;
                        }

                        shiftsPerPosition[positionCode] = shiftsPerPosition[positionCode] || {days: {}};
                        shiftsPerPosition[positionCode]['days'][shift.day] = shiftsPerPosition[positionCode]['days'][shift.day] || [];
                        shiftsPerPosition[positionCode]['days'][shift.day].push(shift);

                        if (ScheduleDataServiceV2.checkConsiderPositionWhileAssigning(brand.id)) {
                            updateUserWorkingHoursPerDayMap(shift);
                        }

                        var shiftToSend = {
                            id: shift.id,
                            position_code: positionCode,
                            end_time: shift.end_time,
                            user_id: shift.user_id,
                            schedule_id: shift.schedule_id,
                            start_time: shift.start_time,
                            code: shift.code
                        };

                        if (shift['labels'] && shift['labels'].length) {
                            shiftToSend['labels'] = shift['labels'];
                        }

                        if (shift['revenue_center_id']) {
                            shiftToSend['revenue_center_id'] = shift['revenue_center_id'];
                        }

                        if (shift['job_titles']) {
                            shiftToSend['job_titles'] = shift['job_titles'];
                        }

                        if (shift['shift_template_id']) {
                            shiftToSend['template_id'] = shift['shift_template_id'];
                        }
                        else {
                            shiftToSend['weight'] = shift.weight;
                        }

                        var isScheduledBreaksEnabled = autoAssignData['scheduleSettings'] && autoAssignData['scheduleSettings']['shift_break_times_mode'] === "MANUAL_ENTRY";
                        var breaksEngines = autoAssignData['scheduleSettings'] && autoAssignData['scheduleSettings']['break_engines'] || [];
                        var excludeBreaksFromRequest = !isScheduledBreaksEnabled && !!shiftToSend['template_id'];

                        if (!excludeBreaksFromRequest && shift.breaks) {
                            let breaks = shift.breaks;

                            if (eligibleUsers[0].recalculateBreaks) {
                                const identifier = getCacheIdentifier(shift, options, eligibleUsers[0].minor ? eligibleUsers[0].userAge : 'ADULT', true);
                                if (shiftBreaksCache[identifier]) {
                                    breaks = shiftBreaksCache[identifier];
                                } else {
                                    const newShift = {...shift, id: 1, user_id: eligibleUsers[0].user_id}
                                    const splitShiftBreaks = [];
                                    const scheduledBreaks = [];
                                    let isBreaksScheduled = true;
                                    for (const breakItem of shift.breaks) {
                                        if (breakItem.type === 'SPLIT_SHIFT') {
                                            splitShiftBreaks.push({...breakItem, id: undefined});
                                        } else {
                                            scheduledBreaks.push(breakItem);
                                            isBreaksScheduled &&= !!breakItem.start_time;
                                        }
                                    }

                                    if (isBreaksScheduled && scheduledBreaks.length > 0) {
                                        const breaksRules = ScheduleCostsServiceV2.getBreaksRulesForDay(shift.day);
                                        const closeTime = ScheduleDataServiceV2.dayCloseHour + ScheduleDataServiceV2.dayCloseHourExtension;

                                        const newRecalculatedBreaks = breaksAutoAssignService.recalculateShiftBreaks(newShift, breaksRules, ScheduleDataServiceV2.dayOpenHour, closeTime);
                                        breaks = splitShiftBreaks.concat(newRecalculatedBreaks);
                                    }

                                    shiftBreaksCache[identifier] = breaks;
                                }
                            }

                            shiftToSend['breaks'] = breaksManagementService.getBreaksListForSave(isScheduledBreaksEnabled, breaksEngines, shift.day, breaks);
                        }

                        var newRole = ScheduleDataServiceV2.getRoleFromPosition(shiftToSend['position_code']);

                        const shiftDay = ScheduleDataServiceV2.getShiftDay(shift);
                        if (newRole) {
                            var roleDayId = ScheduleDataServiceV2.mappings['day_role'][shiftDay + '_' + newRole.id];
                            var assigneeId = roleDayId && ScheduleDataServiceV2.mappings['user_roleday'][shift.user_id + '_' + roleDayId];

                            if (assigneeId) {
                                shiftToSend['role_id'] = newRole.id;
                                shiftToSend['assignee_id'] = assigneeId;
                                delete shiftToSend['user_id'];
                                delete shiftToSend['position_code'];
                            }
                            else if (shiftToSend['user_id']) {
                                shiftToSend['role_id'] = newRole.id;
                                delete shiftToSend['position_code'];
                            }

                        }

                        if (shift.incentive_payments?.length) {
                            shiftToSend.incentive_payments = prepareIncentivePayments(shift, shiftDay)
                        }

                        resultedShifts.push(shiftToSend);

                        if (userEligableShiftsCount[userId]) {
                            userEligableShiftsCount[userId]--;
                        }

                        usersMap[userId] = usersMap[userId] || {};
                        usersMap[userId]['time'] = usersMap[userId]['time'] || 0;
                        usersMap[userId]['time'] += shift['costInfo']['time'];

                        usersMap[userId]['days'] = usersMap[userId]['days'] || {};
                        usersMap[userId]['days'][shift.day] = true;
                        usersMap[userId]['shifts'] = usersMap[userId]['shifts'] || [];
                        usersMap[userId]['shifts'].push(shift);

                        done++;
                        progress = done / shiftsCount;
                        trackProgress(progress);
                    };

                    var now = Date.now();

                    var next = function () {
                        if (shiftsToAssign.length) {
                            var shiftToAssign;

                            if (options && options['weekend_start']) {
                                shiftToAssign = shiftsToAssign.pop();
                            } else {
                                shiftToAssign = shiftsToAssign.shift();
                            }

                            $timeout(function () {
                                findMatchingAssignee(shiftToAssign);
                                next();
                            });
                        }
                        else {
                            if (resultedShifts.length > 0) {
                                console.log("Overall Time (ms):", Date.now() - now);

                                TeamScheduleV2API.bulkEditShifts(brandId, scheduleId, resultedShifts)
                                    .then(function (res) {
                                        clearInterval(updateInterval);
                                        defer.resolve({res: res, requestedShifts: resultedShifts});
                                    })
                                    .catch(function (err) {
                                        var user = TSUsersService.users[err.data.status[0].user_id];

                                        if (err?.status === 400 && err.data?.status[0].errors?.length &&
                                            [
                                                'HIRE_DATE_VIOLATION',
                                                'LEAVE_DATE_VIOLATION',
                                                'POSITION_VIOLATION',
                                                'PAY_TYPE_VIOLATION',
                                                'ACTIVE_USER_VIOLATION'
                                            ].indexOf(err.data.status[0].errors[0].code) > -1
                                        )  {
                                            if (err.data.status[0].errors[0].code === 'HIRE_DATE_VIOLATION') {
                                                HNotifications.show({
                                                    desc: user.name + ' ' + $filter("translate")("is not yet hired and you won’t be able to make any changes"),
                                                    icon: "fa-ban"
                                                });
                                            } else if (err.data.status[0].errors[0].code === 'LEAVE_DATE_VIOLATION') {

                                                HNotifications.show({
                                                    desc: user.name + ' ' + $filter("translate")("is terminated and you won’t be able to make any changes"),
                                                    icon: "fa-ban"
                                                });

                                            } else {
                                                HNotifications.show({
                                                    desc: err.data.status[0].errors[0].details,
                                                    icon: "fa-ban"
                                                });
                                            }
                                        } else if (
                                            err.status === 400 && err.data?.status?.length &&
                                            (err.data.status[0].indexOf('Undeserved break type') > -1 || err.data.status[0].indexOf('Missing deserved scheduled breaks') > -1)
                                        ) {
                                            HNotifications.show({
                                                desc: $filter("translate")("Couldn't auto-assign shifts. Please clear all breaks from unassigned shifts and try again"),
                                                icon: "fa-ban"
                                            });
                                        }
                                    });
                            }
                            else {
                                HNotifications.show({
                                    title: $filter("translate")("Can't Assign Remaining Shifts"),
                                    desc: $filter("translate")("No matched employees with options selected."),
                                    icon: "fa-info-circle",
                                    type: "primary"
                                });
                                clearInterval(updateInterval);
                                defer.reject();
                            }
                        }
                    };


                    if (shiftsToAssign.length > 0) {
                        next();
                    }
                    else {
                        HNotifications.show({
                            title: $filter("translate")("Already Assigned"),
                            desc: $filter("translate")("All shifts are already assigned."),
                            icon: "fa-info-circle",
                            type: "primary"
                        });
                        clearInterval(updateInterval);
                        defer.reject();
                    }
                }).finally(() => {
                    daysFormat = {};
                    usersWorkingHoursPerDayMap = {};
                    minorRuleInBreaksRulesMap = {};
                    usersInfoCache = {};
                });


            return defer.promise;
        };

        self.assignShift = async function(brandId, scheduleId, shift, userId) {

            if (!autoAssignData) {
                await loadDataForAutoAssign();
            }

            usersMap = {};
            shift.user_id = userId;
            var positionCode = shift.position.code;

            if (
                (autoAssignData['crewMemberGroup'] && autoAssignData['crewMemberGroup'].indexOf(positionCode) > -1) ||
                (autoAssignData['managerGroup'] && autoAssignData['managerGroup'].indexOf(positionCode) > -1)
            ) {
                var user = _.findWhere(autoAssignData['users'], {id: userId});
                var userPosition = _.findWhere(user['positions'], function (position) {
                    return (
                        (autoAssignData['crewMemberGroup'] && autoAssignData['crewMemberGroup'].indexOf(position['code']) > -1) ||
                        (autoAssignData['managerGroup'] && autoAssignData['managerGroup'].indexOf(position['code']) > -1)
                    );
                });

                positionCode = userPosition['code'];
            }

            var shiftToSend = {
                position_code: positionCode,
                end_time: shift.end_time,
                user_id: shift.user_id,
                schedule_id: shift.schedule_id,
                start_time: shift.start_time,
                labels: shift['labels'] || [],
                // note: "",
                code: shift.code
            };

            if (shift['revenue_center_id']) {
                shiftToSend['revenue_center_id'] = shift['revenue_center_id'];
            }


            if (shift['job_titles']) {
                shiftToSend['job_titles'] = shift['job_titles'];
            }

            if (shift['shift_template_id']) {
                shiftToSend['template_id'] = shift['shift_template_id'];
            }
            else {
                shiftToSend['weight'] = shift.weight;
            }

            var isScheduledBreaksEnabled = autoAssignData['scheduleSettings'] && autoAssignData['scheduleSettings']['shift_break_times_mode'] === "MANUAL_ENTRY";
            var breaksEngines = autoAssignData['scheduleSettings'] && autoAssignData['scheduleSettings']['break_engines'] || [];
            var excludeBreaksFromRequest = !isScheduledBreaksEnabled && !!shiftToSend['template_id'];

            if (!excludeBreaksFromRequest && shift.breaks?.length) {
                let breaks = shift.breaks ?? [];
                const splitShiftBreaks = [];
                const shiftBreaks = [];
                let hasUnscheduledBreaks = false;
                for (const breakItem of breaks) {
                    if (breakItem.type === 'SPLIT_SHIFT') {
                        splitShiftBreaks.push(breakItem);
                    } else {
                        if (breakItem.start_time) {
                            shiftBreaks.push(breakItem);
                        } else {
                            hasUnscheduledBreaks = true;
                            break;
                        }
                    }
                }

                if (!hasUnscheduledBreaks) {
                    const breaksRules = ScheduleCostsServiceV2.getBreaksRulesForDay(shift.day);
                    const breaksObject = breaksManagementService.calculateShiftDeservedBreaks(breaksRules, shift.day, ScheduleDataServiceV2.dayOpenHour, shift.user_id, shift.position, [shift], true);
                    const deservedBreaks = breaksObject.unpaidBreaks.concat(breaksObject.paidBreaks);

                    if (breaksManagementService.checkIfBreaksNeedsRecalculation(shiftBreaks, deservedBreaks)) {
                        const newShift = {...shift, id: 1};

                        const closeTime = ScheduleDataServiceV2.dayCloseHour + ScheduleDataServiceV2.dayCloseHourExtension;

                        const newRecalculatedBreaks = breaksAutoAssignService.recalculateShiftBreaks(newShift, breaksRules, ScheduleDataServiceV2.dayOpenHour, closeTime);
                        breaks = splitShiftBreaks.concat(newRecalculatedBreaks);
                    }
                }

                shiftToSend['breaks'] =  breaksManagementService.getBreaksListForSave(isScheduledBreaksEnabled, breaksEngines, shift.day, breaks);
            }

            var newRole = ScheduleDataServiceV2.getRoleFromPosition(positionCode);

            const shiftDay = ScheduleDataServiceV2.getShiftDay(shift);
            if (newRole) {
                var roleDayId = ScheduleDataServiceV2.mappings['day_role'][shiftDay + '_' + newRole.id];
                var assigneeId = roleDayId && ScheduleDataServiceV2.mappings['user_roleday'][shift.user_id + '_' + roleDayId];

                if (assigneeId) {
                    shiftToSend['role_id'] = newRole.id;
                    shiftToSend['assignee_id'] = assigneeId;
                    delete shiftToSend['user_id'];
                    delete shiftToSend['position_code'];
                }
                else if (shiftToSend['user_id']) {
                    shiftToSend['role_id'] = newRole.id;
                    delete shiftToSend['position_code'];
                }

            }

            if (shift.incentive_payments?.length) {
                shiftToSend.incentive_payments = prepareIncentivePayments(shift, shiftDay)
            }

            return TeamScheduleV2API.editShift(brandId, scheduleId, shift['id'], shiftToSend)
        };

        var normalizeIntervalsWithOpenTime = function (gfeIntervals) {
            var gfeUsers = gfeIntervals['users'] || [];
            var dayOpen = ShiftTemplateUtils.secondsToTimeObj(ScheduleDataServiceV2.dayOpenHour / 1000);

            for (var i in gfeUsers) {
                var userIntervals = gfeUsers[i]['intervals'];

                for (var j in userIntervals) {
                    var interval = userIntervals[j];
                    var dayOpenTime = moment(interval['start_time']).hours(dayOpen['hours']).minutes(dayOpen['minutes']).valueOf();
                    interval['start_time_value'] = new Date(interval['start_time']).getTime();
                    interval['end_time_value'] = new Date(interval['end_time']).getTime();

                    if (interval['start_time_value'] < dayOpenTime) {
                        interval['start_time_value'] += DAY;
                    }

                    if (interval['end_time_value'] <= interval['start_time_value']) {
                        interval['end_time_value'] += DAY;
                    }
                }
            }

            return {users: gfeUsers};
        };

        var loadGFEIntervals = function (selectedDay) {
            var defer = $q.defer();

            if (activeBrandGFEs) {
                defer.resolve(angular.copy(activeBrandGFEs));
            }
            else {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        var day = Utils.getWeekStart(selectedDay, brand.startDayOfWeek);

                        GoodFaithEstimateAPI.getGFEIntervals(brand.id, day)
                            .then(function (gfeUsers) {
                                activeBrandGFEs = normalizeIntervalsWithOpenTime(gfeUsers);
                                defer.resolve(angular.copy(activeBrandGFEs));
                            })
                            .catch(function (err) {
                                console.error(err);
                                defer.resolve({});
                            });
                    });

            }

            return defer.promise;
        };

        var loadBrandServices = function () {
            var defer = $q.defer();
            var brandServices = {};

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    var promises = {
                        isMcDLaborServiceEnabled: userServices.isServiceEnabled(userServices.SERVICES.MCD_LABOR_MODEL, brand.id)
                    };

                    $q.all(promises)
                        .then(function (res) {
                            brandServices['isMcDLaborServiceEnabled'] = res['isMcDLaborServiceEnabled'];
                            defer.resolve(brandServices);
                        })
                        .catch(function (err) {
                            console.error(err);
                            defer.resolve({});
                        });
                });

            return defer.promise;
        };

        var getCrewGroupPositions = function () {
            return ['crew-member', 'crew-trainer', 'backup-maintenance-person', 'primary-maintenance-person'];
        };

        var getManagerGroupPositions = function () {
            return [
                'dept-mgr-iii-w-crew-punches-1', 'area-manager-grill-ca', 'store-manager-trainee-f', 'department-manager-i',
                'department-manager-iii', 'dept-mgr-i-w-crew-punches-1', 'dept-mgr-ii-w-crew-punches-1', 'general-manager',
                'general-manager-w-crew-punches', 'general-manager-w-mgr-punches', 'manager-oje', 'floor-supervisor',
                'certified-swing-manager-', 'shift-manager-trainee', 'security-guard', 'department-manager-ii'
            ];
        };

        var loadDataForAutoAssign = function (viewOptions, options) {
            var defer = $q.defer();

            var promises = {
                activeBrand: TeamScheduleService.getActiveBrand(),
                users: getActiveBrandTeamMembers(),
                costsMap: ScheduleCostsServiceV2.getUsersCostsMap(),
                scheduleSettings: ScheduleCostsServiceV2.getBrandScheduleSettings(),
                brandServices: loadBrandServices(),
            };

            if (options && options['consider_gfe']) {
                promises['gfeIntervals'] = loadGFEIntervals(viewOptions['day']);
            }

            $q.all(promises)
                .then(function (result) {
                    autoAssignData = result;

                    if (result['brandServices']['isMcDLaborServiceEnabled']) {
                        autoAssignData['crewMemberGroup'] = getCrewGroupPositions();
                        autoAssignData['managerGroup'] = getManagerGroupPositions();
                    }

                    defer.resolve();
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.getEligibleUsers = function (slot, viewOptions, options) {

            var defer = $q.defer();

            usersShiftKnockoutMap = {};

            loadDataForAutoAssign(viewOptions, options)
                .then(function () {
                    daysFormat = {};
                    usersWorkingHoursPerDayMap = {};
                    usersInfoCache = {};
                    const breaksRules = ScheduleCostsServiceV2.getBreaksRulesForDay(slot.day);
                    minorRuleInBreaksRulesMap[slot.day] = breaksManagementService.checkIfThereIsOneMinorRule(breaksRules?.values);
                    const brand = TeamScheduleService.getBrandById(ScheduleDataServiceV2.brandId);
                    const nowInBrandTimezone = moment(Utils.getNowInBrandTimezoneByTimeZoneName(brand.timezoneName).format("YYYY-MM-DDTHH:mm:ss.SSS"));
                    const eligibleUsers = getEligibleUsers(slot, brand, nowInBrandTimezone);
                    if (
                        isPositionOrderedApplied(brand.id) &&
                        slot.job_titles?.length &&
                        runnerCodes.includes(slot.position?.code)
                    ) {
                        //sort food runner users first then waiter then head runner..
                        eligibleUsers.sort((user1, user2) => {
                            const user1Position = user1.userPosition.code;
                            const user2Position = user2.userPosition.code;

                            let positionCriteria = getPositionSortCriteria(runnerCodes, user1Position, user2Position, false);

                            if (positionCriteria !== 0) {
                                return positionCriteria;
                            }

                            positionCriteria = getPositionSortCriteria(waiterCodes, user1Position, user2Position, false);

                            if (positionCriteria !== 0) {
                                return positionCriteria;
                            }

                            positionCriteria = getPositionSortCriteria(headWaiterCodes, user1Position, user2Position, false);

                            if (positionCriteria !== 0) {
                                return positionCriteria;
                            }

                            return getUserSortValue(user1, user2);
                        });
                    }
                    defer.resolve(eligibleUsers);
                })
                .catch(function (err) {
                    defer.reject(err);
                }).finally(() => {
                    daysFormat = {};
                    usersWorkingHoursPerDayMap = {};
                    minorRuleInBreaksRulesMap = {};
                    usersInfoCache = {};
                });

            return defer.promise;
        };

        var getJobTitleUserMatch = function (slot, user) {
            var userJobTitles = (ScheduleDataServiceV2.usersJobTiles && ScheduleDataServiceV2.usersJobTiles[user.id]) || {};
            var shiftJobTitles = slot.job_titles || [];
            var result = {match: 0, missing: 0, total_score: 0, total_level: 0, avg_level: 0};

            for (var i in shiftJobTitles) {
                var shiftJT = shiftJobTitles[i];
                var userJT = userJobTitles[shiftJT['job_title_id']];

                if (userJT && userJT['level'] <= 3) {
                    result['match']++;
                    result['total_score'] += (6 - userJT['level']);
                    result['total_level'] += userJT['level'];
                }
                else {
                    result['missing']++;
                }
            }

            if (result['total_level']) {
                result['avg_level'] = result['total_level'] / result['match'];
            }

            return result;
        };

        var getSkillLevel = function (slot, user, brandId) {
            var userJobTitles = ScheduleDataServiceV2.usersJobTiles && ScheduleDataServiceV2.usersJobTiles[user.id];
            var shiftPrimaryJobTitle = slot.job_titles && _.findWhere(slot.job_titles, {type: 'PRIMARY'});

            if (shiftPrimaryJobTitle && userJobTitles && userJobTitles[shiftPrimaryJobTitle.job_title_id]) {
                var jobTile = userJobTitles[shiftPrimaryJobTitle.job_title_id];
                return {id: jobTile.level, name: jobTile.name, level: (6 - jobTile.level)};
            } else {
                var userPosition = user.positions.find(function (item) {
                    if (autoAssignData['crewMemberGroup'] && autoAssignData['crewMemberGroup'].indexOf(item.code) > -1) {
                        return true;
                    } else if (autoAssignData['managerGroup'] && autoAssignData['managerGroup'].indexOf(item.code) > -1) {
                        return true;
                    } else if (isPositionOrderedApplied(brandId) && item.code !== slot.position.code) {
                        return (
                            waiterCodes.includes(item.code) ||
                            headWaiterCodes.includes(item.code)
                        )
                    } else {
                        return item.code === slot.position.code;
                    }
                });

                return userPosition.skill_level;
            }
        };

        var getRestBetweenDaysSeconds = function (user, rule) {
            var restPeriod = 43200;

            if (rule && rule['pay_types']) {
                var userActivePayType = TSUsersService.getUserActivePayType(user.id, ScheduleDataServiceV2.StartDate, 'WEEKLY');
                var isEligiblePayType = rule['pay_types'].findIndex(function (payType) {
                    return payType['payment_type'] === userActivePayType;
                }) > -1;

                if (isEligiblePayType) {
                    restPeriod = rule['rest_period'] + 1;
                }
            }

            return restPeriod
        };

        var isClopening = function (shift1, shift2, user) {
            var restBetweenDaysRule = autoAssignData['scheduleSettings'] && autoAssignData['scheduleSettings']['right_to_rest_compliance_settings'];
            var restBetweenDaysHours = getRestBetweenDaysSeconds(user, restBetweenDaysRule) / 3600;
            var numberOfHours = getMinutesBetweenShifts(shift1, shift2) / 60;

            if (numberOfHours >= 0 && numberOfHours < restBetweenDaysHours) {
                return true;
            }

            numberOfHours = getMinutesBetweenShifts(shift2, shift1) / 60;

            if (numberOfHours >= 0 && numberOfHours < restBetweenDaysHours) {
                return true;
            }

            return false;
        };

        var isMarkedOffDay = function (userId, slotDay) {
            if (ScheduleDataServiceV2.markedOffDays && ScheduleDataServiceV2.markedOffDays[userId]) {
                return ScheduleDataServiceV2.markedOffDays[userId].findIndex(function (day) {
                    return moment(day.date).isSame(moment(slotDay), 'day');
                }) > -1;
            }

            return false;
        }

        const getUserScheduledShifts = (userId) => {
            let userCurrentLocationScheduledShifts = ScheduleDataServiceV2.flatData?.users?.[userId]?.shift_ids ?? [];
            let userCrossLocationScheduledShifts = [];

            for (const brandId in ScheduleDataServiceV2.crossFlatData) {
                const userShifts = ScheduleDataServiceV2.crossFlatData[brandId]?.users?.[userId]?.shift_ids ?? [];
                if (userShifts.length) {
                    userCrossLocationScheduledShifts.push({
                        brand_id: brandId,
                        shifts: userShifts,
                    })
                }
            }

            return [
                {
                    brand_id: ScheduleDataServiceV2.brandId,
                    shifts: userCurrentLocationScheduledShifts
                },
                ...userCrossLocationScheduledShifts,
            ];
        };

        const getUserDayBeforeScheduledShifts = (userId) => {
            const userDayBeforeCurrentLocationShifts = ScheduleDataServiceV2.extraDayFlatData?.users?.[userId]?.shift_ids ?? [];
            const userDayBeforeCrossLocationShifts = [];

            for (const shiftId in ScheduleDataServiceV2.extraCrossDayFlatData.shifts) {
                const shift = ScheduleDataServiceV2.extraCrossDayFlatData.shifts[shiftId];
                if (shift.user_id === userId) {
                    userDayBeforeCrossLocationShifts.push(shift.id);
                }
            }

            return [
                {
                    cross: false,
                    shifts: userDayBeforeCurrentLocationShifts,
                },
                {
                    cross: true,
                    shifts: userDayBeforeCrossLocationShifts,
                }
            ]
        }

        const updateUserWorkingHoursPerDayMap = (shift) => {
            if (shift) {
                usersWorkingHoursPerDayMap[shift.user_id] ??= {DAYS: {}};
                usersWorkingHoursPerDayMap[shift.user_id].DAYS[shift.day] ??= {totalHours: 0, shiftsMap: {}};
                if (!usersWorkingHoursPerDayMap[shift.user_id].DAYS[shift.day].shiftsMap[shift.id]) {
                    usersWorkingHoursPerDayMap[shift.user_id].DAYS[shift.day].totalHours += shift.period ?? 0;
                    usersWorkingHoursPerDayMap[shift.user_id].DAYS[shift.day].shiftsMap[shift.id] = true;
                }
            }
        }

        /**
         * returns a map of the previous, current and next day of a shift.
         * @param shiftDay the shift day
         * @returns {{previousDay: string, currentDay: string, nextDay: string}}
         */
        const getDaysMap = (shiftDay) => {
            return {
                previousDay: moment(shiftDay).clone().subtract(1, 'days').format('MMM DD, YYYY'),
                currentDay: moment(shiftDay).format('MMM DD, YYYY'),
                nextDay: moment(shiftDay).clone().add(1, 'days').format('MMM DD, YYYY'),
            };
        }

        const checkForDoubleShiftViolationWithADay = (day, shiftLength, userId) => {
            let willCauseViolation = false;

            if (usersWorkingHoursPerDayMap[userId]?.DAYS[day]?.totalHours) {
                willCauseViolation = ((usersWorkingHoursPerDayMap[userId]?.DAYS[day]?.totalHours ?? 0) + shiftLength) > DOUBLE_SHIFT_HOURS_VIOLATION;
            }

            return willCauseViolation;
        }

        /**
         * logic of the double shift
         * while doing the auto assign we are going to map for each user how many hours they are have worked per each day (the value is stored in usersWorkingHoursPerDayMap var)
         * we are checking the sum of hours of the previous day and the current day or the sum of next day and the current day (as the user could have already scheduled shifts), if the one of the values is more than 20 hours then we do not continue
         * if the user is failing the above criteria then they should be knocked out of the auto assign.
         * @param shift the shift to do the check on
         * @param userId the user to do the check on
         * @returns {boolean} true if assigning the shift is going to violate the criteria, false if not
         */
        const checkForDoubleShiftViolation = (shift, userId) => {
            daysFormat[shift.day] ??= getDaysMap(shift.day);
            const shiftLength = (shift.length ?? 0) / HOUR;

            return (
                checkForDoubleShiftViolationWithADay(daysFormat[shift.day].previousDay, shiftLength, userId) ||
                checkForDoubleShiftViolationWithADay(daysFormat[shift.day].nextDay, shiftLength, userId)
            );
        }

        /**
         * get the specified user info either from the cache or to be calculated.
         * this is using the variable usersInfoCache as the cache source.
         * @param user the user to operate on
         * @param day the day of the operation
         * @param nowInBrandTimeZone current time in brand time zone (needed in some operations & the cache identifier)
         * @param infoCode {'ACTIVE_ON_LOCATION'|'HAS_EFFECTIVE_LOA'|'USER_AGE'} the code for the needed information
         * @returns {boolean|number} returns a boolean for when infoCode === ['ACTIVE_ON_LOCATION'|'HAS_EFFECTIVE_LOA'] or number when infoCode === 'USER_AGE'
         */
        const getUserInfo = (user, day, nowInBrandTimeZone, infoCode) => {
            const identifier = `${user.id}_${day}_${nowInBrandTimeZone}`;

            if (usersInfoCache[identifier]?.[infoCode] !== undefined) {
                return usersInfoCache[identifier]?.[infoCode];
            }

            usersInfoCache[identifier] ??= {};
            let data;

            switch (infoCode) {
                case 'ACTIVE_ON_LOCATION':
                    data = user.isDateWithinActiveOrScheduledLocationPeriod(day, nowInBrandTimeZone);
                    break;
                case 'HAS_EFFECTIVE_LOA':
                    data = user.hasEffectiveLOA(day);
                    break;
                case 'USER_AGE':
                    data = user.getUserAge(day);
                    break;
            }

            usersInfoCache[identifier][infoCode] = data;

            return usersInfoCache[identifier][infoCode];
        }

        const getEligibleUsers = (slot, brand, nowInBrandTimezone, excludeUsers, options, ignorePossibleShifts) => {

            var eligibleUsers = [];
            var newlyHiredMap = {};
            excludeUsers = excludeUsers || [];
            const hasMinorBreakRule = !!minorRuleInBreaksRulesMap[slot.day];

            var users = autoAssignData['users'];
            var costsMap = autoAssignData['costsMap'];
            var gfeIntervalsUsers = autoAssignData['gfeIntervals'] && autoAssignData['gfeIntervals']['users'];
            var userPosition = slot.position;
            let usersPositionsMap = {}

            let suitableUsers = users.filter(function (user) {
                if (options && options['selected_users']?.indexOf(user.id) === -1) {
                    return false;
                }

                let includedUser = !options || !options['assign_only_new_hire'] || (options['assign_only_new_hire'] && ScheduleDataServiceV2.isNewlyHied(slot.day, user.id, true));
                let matchedPosition = (excludeUsers.indexOf(user.id) === -1) && user['positions']?.find(function (item) {
                    if (autoAssignData['crewMemberGroup'] && autoAssignData['crewMemberGroup'].indexOf(item.code) > -1 && autoAssignData['crewMemberGroup'].indexOf(userPosition.code) > -1 ) {
                        usersPositionsMap[user.id] = item;
                        return true;
                    } else if (autoAssignData['managerGroup'] && autoAssignData['managerGroup'].indexOf(item.code) > -1 && autoAssignData['managerGroup'].indexOf(userPosition.code) > -1) {
                        usersPositionsMap[user.id] = item;
                        return true;
                    } else if (
                        isPositionOrderedApplied(brand.id) &&
                        runnerCodes.includes(userPosition.code) &&
                        slot.job_titles?.length && (
                            runnerCodes.includes(item.code) ||
                            waiterCodes.includes(item.code) ||
                            headWaiterCodes.includes(item.code)
                        )
                    ) {
                        usersPositionsMap[user.id] = user.positions?.find((position) => runnerCodes.includes(position.code)) ?? item;
                        return true;
                    } else {
                        usersPositionsMap[user.id] = item;
                        return item.code === slot.position.code;
                    }
                });

                return matchedPosition && includedUser;
            });

            avgHoursPerUser[userPosition.code] = totalShiftsHours[userPosition.code] && (totalShiftsHours[userPosition.code] / suitableUsers.length);

            if (ScheduleDataServiceV2.checkConsiderPositionWhileAssigning(brand.id)) {
                for (var u in suitableUsers) {
                    var user = suitableUsers[u];
                    newlyHiredMap[user.id] = {isNewlyHied: user.isNewlyHied(slot.day, NEW_HIRED_THRESHOLD)};
                }

                suitableUsers = suitableUsers.sort(function (user1, user2) {
                    var isUser1NewlyHired = newlyHiredMap[user1.id]['isNewlyHied'];
                    var isUser2NewlyHired = newlyHiredMap[user2.id]['isNewlyHied'];

                    if (isUser1NewlyHired && !isUser2NewlyHired) {
                        return 1;
                    }

                    if (isUser2NewlyHired && !isUser1NewlyHired) {
                        return -1;
                    }

                    return 0;
                });
            }

            for (var i in suitableUsers) {
                var user = suitableUsers[i];

                if (usersShiftKnockoutMap[user.id + '_' + slot.id]) {
                    continue;
                }

                if (user['schedulable'] !== 'REGULAR') {
                    continue;
                }

                if (!getUserInfo(user, slot.day, nowInBrandTimezone, 'ACTIVE_ON_LOCATION')) {
                    continue;
                }

                if (getUserInfo(user, slot.day, nowInBrandTimezone, 'HAS_EFFECTIVE_LOA')) {
                    continue;
                }

                var userCostMap = costsMap[user.id] || {};
                let userPos = usersPositionsMap[user.id];
                let userPositionCostMap = userCostMap[userPos.code] || {};
                var userPositionDayCostMap = userPositionCostMap[slot.day] || {};
                var userMaxWeeklyHours = userCostMap['max_weekly_hours'] || {};
                var userMaxWeeklyHoursDay = userMaxWeeklyHours[slot.day];

                var skillLevel = getSkillLevel(slot, user, brand.id);
                var userId = user.id;

                const userScheduledShifts = getUserScheduledShifts(userId);
                const userScheduledShiftsDayBefore = getUserDayBeforeScheduledShifts(userId);
                var userScheduledSameDay = usersMap[userId] && usersMap[userId]['days'] && usersMap[userId]['days'][slot['day']];

                var userScheduledHrs = 0;
                var userWeeklyHours = 0;
                var alreadyScheduledSameTime = false;
                var alreadyScheduledSameDay = 0;
                var willCauseClopening = false;
                var isUnavailable = false;
                var hasDaysOff = false;
                var requestedUnavailability = false;
                var isWorkable = false;
                var expertEmployeesCount = 0;
                var workableOverlapPerc = 0;

                usersMap[userId] = usersMap[userId] || {};
                usersMap[userId]['days'] = usersMap[userId]['days'] || {};

                var gfeRulesValid = true;
                var shiftJTResult;

                const checkShiftJobTitles = (
                    !options ||
                    options['match_job_title'] || (
                        isPositionOrderedApplied(brand.id) &&
                        runnerCodes.includes(slot.position.code)
                    )
                );

                if (checkShiftJobTitles) {
                    shiftJTResult = getJobTitleUserMatch(slot, user);
                }

                if (options && options['consider_gfe']) {
                    var userGFE = gfeIntervalsUsers.find(function (item) {
                        return item.id === userId;
                    });

                    if (userGFE && userGFE.intervals) {
                        gfeRulesValid = false;

                        for (var j in userGFE.intervals) {
                            var interval = userGFE.intervals[j];

                            if (isWithin(slot, interval)) {
                                gfeRulesValid = true;
                                break;
                            }
                        }
                    } else if (options['assign_only_new_hire']) {
                        gfeRulesValid = false;
                    }
                }

                for (const brandInfo of userScheduledShifts) {
                    for (const shiftId of brandInfo.shifts) {
                        let shift = ScheduleDataServiceV2.flatData.shifts[shiftId];
                        if (brandInfo.brand_id !== ScheduleDataServiceV2.brandId) {
                            shift = ScheduleDataServiceV2.crossFlatData[brandInfo.brand_id].shifts[shiftId]
                        }

                        if (ScheduleDataServiceV2.checkConsiderPositionWhileAssigning(brand.id)) {
                            updateUserWorkingHoursPerDayMap(shift);
                        }

                        if (shift) {
                            userScheduledHrs += shift['costInfo']['time'];
                            userWeeklyHours += shift['period'];

                            if (!alreadyScheduledSameTime && doOverlap(shift, slot)) {
                                alreadyScheduledSameTime = true;
                                break;
                            }

                            if (!alreadyScheduledSameDay && shift['day'] === slot['day']) {
                                alreadyScheduledSameDay += shift['costInfo']['time'];
                            }

                            if (isClopening(shift, slot, user)) {
                                willCauseClopening = true;
                                break;
                            }

                            usersMap[userId]['days'][shift['day']] = true;
                        }
                        else {
                            console.log("Not found:", shiftId, "user:", user.id)
                        }
                    }
                }

                for (const brandInfo of userScheduledShiftsDayBefore) {
                    for (const shiftId of brandInfo.shifts) {
                        let shift = ScheduleDataServiceV2.extraDayFlatData['shifts'][shiftId];
                        if (brandInfo.cross) {
                            shift = ScheduleDataServiceV2?.extraCrossDayFlatData?.shifts?.[shiftId];
                        }

                        if (ScheduleDataServiceV2.checkConsiderPositionWhileAssigning(brand.id)) {
                            updateUserWorkingHoursPerDayMap(shift);
                        }

                        if (shift && isClopening(shift, slot, user)) {
                            willCauseClopening = true;
                            break;
                        }
                    }
                }

                var userAvailabilities = ScheduleDataServiceV2.availabitlies[user.id] || [];
                var userDontHaveDefinedWorkable = true;


                for (var j in userAvailabilities) {
                    if (userAvailabilities[j].type === 'WORKABLE') {

                        userDontHaveDefinedWorkable = false;

                        if (!isWorkable && userAvailabilities[j].status === 'APPROVED') {
                            if (options && options['consider_preferred_policy'] === 'CONSIDER') {
                                if (doOverlap(slot, userAvailabilities[j])) {
                                    isWorkable = true;
                                    workableOverlapPerc = getIntersectionPerc(slot, userAvailabilities[j]);
                                }
                            }
                            else {
                                if (isWithin(slot, userAvailabilities[j])) {
                                    isWorkable = true;
                                }
                            }
                        }
                    } else if (userAvailabilities[j].type === 'AVAILABILITY') {
                        if (!isUnavailable) {
                            if (options && options['consider_preferred_policy'] === 'CONSIDER') {
                                if (isWithin(slot, userAvailabilities[j])) {
                                    if (userAvailabilities[j].status === 'APPROVED') {
                                        isUnavailable = true;
                                    } else {
                                        requestedUnavailability = true;
                                    }
                                }
                            } else {
                                if (doOverlap(slot, userAvailabilities[j])) {
                                    if (userAvailabilities[j].status === 'APPROVED') {
                                        isUnavailable = true;
                                    } else {
                                        requestedUnavailability = true;
                                    }
                                }
                            }
                        }
                    } else {
                        if (!hasDaysOff && doOverlap(slot, userAvailabilities[j])) {
                            if (userAvailabilities[j].status === 'APPROVED') {
                                hasDaysOff = true;
                            }
                            else {
                                requestedUnavailability = true;
                            }
                        }
                    }
                }

                if (isMarkedOffDay(user.id, slot.day)) {
                    if (options && options['consider_requests']) {
                        hasDaysOff = true;
                    } else {
                        requestedUnavailability = true;
                    }
                }

                if (userDontHaveDefinedWorkable && !isUnavailable && options && options['consider_preferred'] && options['consider_preferred_policy'] === 'CONSIDER') {
                    isWorkable = true;
                    workableOverlapPerc = 90;
                }

                var hrs = (userScheduledHrs + slot['costInfo']['time']) / 3600;
                var workHrs = userWeeklyHours + slot['period'];

                var maxHours = (userMaxWeeklyHoursDay && userMaxWeeklyHoursDay['value']) || 40;
                var exceedsMaxHoursValue = (hrs / maxHours);
                var exceedsWeeklyMaxHours = workHrs > maxHours;

                var exceedsAvgHoursPerUserVal = (hrs / avgHoursPerUser[userPosition.code]);

                var isMinor = user.isMinor(slot['start_time']);
                var minorsRulesValid = true;
                var workVisaRulesValid = true;
                var userShifts = angular.copy(usersMap[userId] && usersMap[userId]['shifts'] || []).concat(slot);

                if (isMinor) {
                    minorsRulesValid = minorSchedulingService.isUserPassMinorRules(ScheduleDataServiceV2.startDate, user.id, userShifts);
                }

                if (user.hasWorkVisa()) {
                    workVisaRulesValid = workVisasService.isUserPassWorkVisaRules(ScheduleDataServiceV2.startDate, user.id, userShifts);
                }

                let willCauseDoubleShiftViolation = false;

                if (ScheduleDataServiceV2.checkConsiderPositionWhileAssigning(brand.id)) {
                    if (newlyHiredMap[user.id] && newlyHiredMap[user.id].isNewlyHied) {
                        var shiftsWithSamePosition = (
                            shiftsPerPosition[userPosition.code] &&
                            shiftsPerPosition[userPosition.code]['days'] &&
                            shiftsPerPosition[userPosition.code]['days'][slot.day]
                        ) || [];

                        for (var s in shiftsWithSamePosition) {
                            var otherShift = shiftsWithSamePosition[s];
                            var otherUser = _.findWhere(users, {id: otherShift.user_id})
                            var otherUserSkill = getSkillLevel(otherShift, otherUser, brand.id);

                            if (otherUserSkill >= 4 && doOverlap(slot, otherShift)) {
                                expertEmployeesCount++;

                                if (expertEmployeesCount === 2) {
                                    break;
                                }
                            }
                        }
                    }

                    //Double shift violation
                    willCauseDoubleShiftViolation = checkForDoubleShiftViolation(slot, userId);
                }

                alreadyScheduledSameDay = alreadyScheduledSameDay || userScheduledSameDay;

                var numberOfScheduledDays = Object.keys(usersMap[userId]['days']).length;

                var knockout = false;

                if (options) {
                    if (alreadyScheduledSameDay) {
                        knockout = true;
                    }

                    if (!gfeRulesValid) {
                        knockout = true;
                    }

                    if (numberOfScheduledDays >= (options['maximum_days'] || 5)) {
                        knockout = true;
                    }

                    if (shiftJTResult && shiftJTResult['missing'] > 0 && (autoAssignData['brandServices']['isMcDLaborServiceEnabled'] || shiftJTResult['match'] === 0)) {
                        knockout = true;
                    }

                    if (options && options['consider_preferred']) {
                        if (!isWorkable && options['consider_preferred_policy'] === 'ALWAYS') {
                            knockout = true;
                        } else if (!isWorkable && isUnavailable) {
                            knockout = true;
                        }
                    }

                    if (options && options['consider_requests'] && hasDaysOff) {
                        knockout = true;
                    }
                }

                if (willCauseClopening) {
                    knockout = true;
                }

                if (alreadyScheduledSameTime) {
                    knockout = true;
                }

                if (!minorsRulesValid) {
                    knockout = true;
                }

                if (!workVisaRulesValid) {
                    knockout = true;
                }

                if (newlyHiredMap[user.id] && newlyHiredMap[user.id].isNewlyHied && expertEmployeesCount < 2) {
                    knockout = true;
                }

                if (ScheduleDataServiceV2.checkConsiderPositionWhileAssigning(brand.id) && (exceedsWeeklyMaxHours || willCauseDoubleShiftViolation)) {
                    knockout = true;
                }

                if (!knockout) {
                    var usrData = {
                        busy_shift_position: slot['is_busy'] && slot['is_busy']['position'],
                        busy_shift_overall: slot['is_busy'] && slot['is_busy']['overall'],
                        possible_shifts: ignorePossibleShifts? -1: userEligableShiftsCount[userId] || 0,
                        user_id: user.id,
                        user: user,
                        userPosition: userPos,
                        skillLevel: skillLevel,
                        checkShiftJobTitles: checkShiftJobTitles,
                        exceedsAvgHoursPerUserVal: exceedsAvgHoursPerUserVal,
                        alreadyScheduledSameDay: alreadyScheduledSameDay,
                        numberOfScheduledDays: numberOfScheduledDays,
                        userScheduledHrs: userScheduledHrs,
                        exceedsMaxHoursValue: exceedsMaxHoursValue,
                        isWorkable: isWorkable,
                        workableOverlapPerc: workableOverlapPerc,
                        isUnavailable: isUnavailable,
                        hasDaysOff: hasDaysOff,
                        shiftJTResult: shiftJTResult,
                        requestedUnavailability: requestedUnavailability,
                        minor: isMinor,
                        userAge: getUserInfo(user, slot.day, nowInBrandTimezone, 'USER_AGE'),
                        recalculateBreaks: isMinor && hasMinorBreakRule,
                        rate: userPositionDayCostMap['rate']
                    };

                    usrData['score'] = calculateScore(usrData, options);
                    eligibleUsers.push(usrData);
                }
                else {
                    usersShiftKnockoutMap[user.id + '_' + slot.id] = true;
                }
            }

            return applySortCriteria(eligibleUsers);
        };

        self.reset = function () {
            activeBrandUsers = null;
            activeBrandGFEs = null;
            autoAssignData = null;
        };
    }

    app.service('autoSchedulingService', AutoSchedulingService);
}());